import styles from "../styles/planesSalut.module.css";
import { Link } from "react-router-dom";


function PlanesSalut() {
    const plans = [
        { tipo:"Salut",name: "BASIC", price: "9.80€", texto1:'Fisioterapia',texto2:'Entrenamientos',texto3:'Medicina',texto4:'Omeopatia',texto5:'Masaje',texto6:'Alimentación' },
        { tipo: "Salut", name: "STANDARD", price: "19.80€", texto1: 'Fisioterapia', texto2: 'Control de comidas', texto3: 'Medicina', texto4: 'Nutrición', texto5: 'Dietas', texto6: 'Asesoramiento' },
        { tipo: "Salut",name: "PREMIUM", price: "29.80€", texto1: 'FisioterapiaXL', texto2: 'Entrenamientos PRO', texto3: 'Medicina Extra', texto4: 'Omeopatia', texto5: 'Masaje', texto6: 'Nutrición Premium' },
    ];

    return (
        <section className={styles.pricing}>
            <h2>Planes Salut</h2>
            <div className={styles.plans}>
                {plans.map((plan, index) => (
                    <div key={index} className={styles.plan}>
                        <h3>{plan.name}</h3>
                        <p>{plan.price}</p>
                        <p>{plan.texto1}</p>
                        <p>{plan.texto2}</p>
                        <p>{plan.texto3}</p>
                        <p>{plan.texto4}</p>
                        <p>{plan.texto5}</p>
                        <p>{plan.texto6}</p>
                        
                                        
                        <button>
                            <Link
                                className={styles.linkButton}
                                to='/contacto' // La ruta es directa
                                state={{ planSeleccionado: plan }} // El state es una prop aparte
                            >
                                Elegir
                            </Link>
                        </button>
                        
                    </div>
                ))}
            </div>
         
        </section>
    );
}

export default PlanesSalut;
